import React, { Component } from 'react';
import { Tag } from 'lucide-react';
import i18n from '../../../../../i18n';

const lng = localStorage.getItem('I18N_LANGUAGE');

class PropertyDetails extends Component {
    render() {
        const { auction } = this.props;
        const attributes = auction?.attributes || [];

        if (!attributes.length) return null;

        return (
            <React.Fragment>
                {attributes.map((attr) => (
                    <div className="ad-panel" key={attr.id}>
                        <div className="ad-panel-header">
                            {/* <Tag size={16} /> */}
                            <i className={'fa ' + attr?.icon} />
                            {lng === 'ar' ? attr.name_ar : attr.name}
                        </div>
                        <div className="ad-panel-body">
                            <div className="ad-amount-row">
                                <span className="ad-amount-val">
                                    {attr.value || '—'}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </React.Fragment>
        );
    }
}

export default PropertyDetails;